import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/contexts/AuthContext";

/**
 * Hook para obter a contagem de atividades pendentes atribuidas ao usuario logado
 * Inclui: "Fazer Amizade" (etapas ativas) e "Mencoes"
 */
export function useActivityPendingCount() {
  const { user } = useAuth();

  return useQuery({
    queryKey: ["activity_pending_count", user?.id],
    queryFn: async () => {
      if (!user?.id) return 0;

      // PERF: uma única query (or aninhado) em vez de 2 HEADs separados em toda
      // navegação. Falar com Frila pendente (etapas ativas do kanban) OU Menção
      // pendente, atribuídas ao usuário logado.
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const { count, error } = await (supabase as any)
        .from("activities")
        .select("*", { count: "exact", head: true })
        .eq("assigned_to", user.id)
        .or(
          "and(tipo.eq.falar_com_frila,etapa_kanban.in.(pendente,em_contato))," +
            "and(tipo.eq.mencao,status.eq.pending)",
        );

      if (error) {
        console.error("Erro ao buscar contagem de atividades pendentes:", error);
        return 0;
      }

      return count || 0;
    },
    enabled: !!user?.id,
    refetchInterval: 60000, // Atualiza a cada 1 minuto
    staleTime: 30000, // Considera stale apos 30 segundos
  });
}
